import React from 'react';
import {
  Box,
  Container,
  Typography,
  Link,
  Stack,
  Divider,
} from '@mui/material';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      component="footer"
      sx={{
        bgcolor: '#FFFFFF',
        borderTop: '1px solid rgba(55, 65, 81, 0.1)',
        py: 8,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gap: 5 }}>
          {/* Company Info */}
          <Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: 40,
                  height: 40,
                  borderRadius: '10px',
                  background: 'linear-gradient(135deg, #374151 0%, #1F2937 100%)',
                }}
              >
                <RocketLaunchIcon sx={{ color: 'white', fontSize: 22 }} />
              </Box>
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 800,
                  background: 'linear-gradient(135deg, #374151 0%, #1F2937 100%)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                }}
              >
                InnoVate
              </Typography>
            </Box>
            <Typography variant="body2" sx={{ color: '#6B7280', lineHeight: 1.8 }}>
              Building exciting mobile games and apps in Bahawalpur, Pakistan. Creating fun experiences for users worldwide since 2025.
            </Typography>
          </Box>

          {/* Quick Links */}
          <Box>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 700, color: '#1F2937', mb: 2 }}>
              Company
            </Typography>
            <Stack spacing={1.5}>
              <Link
                component={RouterLink}
                to="/about"
                sx={{
                  color: '#6B7280',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  transition: 'all 0.2s ease',
                  '&:hover': { color: '#374151', transform: 'translateX(4px)' },
                  display: 'inline-block',
                }}
              >
                About Us
              </Link>
              <Link
                component={RouterLink}
                to="/games"
                sx={{
                  color: '#6B7280',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  transition: 'all 0.2s ease',
                  '&:hover': { color: '#374151', transform: 'translateX(4px)' },
                  display: 'inline-block',
                }}
              >
                Our Games & Apps
              </Link>
            </Stack>
          </Box>

          {/* Services */}
          <Box>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 700, color: '#1F2937', mb: 2 }}>
              Services
            </Typography>
            <Stack spacing={1.5}>
              {['Unity Game Development', 'Flutter App Development', 'UI/UX Design', 'Game & App Support'].map((item) => (
                <Typography
                  key={item}
                  variant="body2"
                  sx={{ color: '#6B7280', fontSize: '0.9rem' }}
                >
                  {item}
                </Typography>
              ))}
            </Stack>
          </Box>

          {/* Legal */}
          <Box>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 700, color: '#1F2937', mb: 2 }}>
              Legal
            </Typography>
            <Stack spacing={1.5}>
              <Link
                component={RouterLink}
                to="/privacy-policy"
                sx={{
                  color: '#6B7280',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  transition: 'all 0.2s ease',
                  '&:hover': { color: '#374151', transform: 'translateX(4px)' },
                  display: 'inline-block',
                }}
              >
                Privacy Policy
              </Link>
              <Link
                component={RouterLink}
                to="/terms-of-service"
                sx={{
                  color: '#6B7280',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  transition: 'all 0.2s ease',
                  '&:hover': { color: '#374151', transform: 'translateX(4px)' },
                  display: 'inline-block',
                }}
              >
                Terms of Service
              </Link>
            </Stack>
          </Box>

          {/* Contact */}
          <Box>
            <Typography variant="subtitle1" gutterBottom sx={{ fontWeight: 700, color: '#1F2937', mb: 2 }}>
              Contact
            </Typography>
            <Stack spacing={1.5}>
              <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '0.9rem' }}>
                House no. 311 street 17 Villa comunity DHA Bahawalpur
              </Typography>
              <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '0.9rem' }}>
                info@innovategames.net
              </Typography>
              <Link
                component={RouterLink}
                to="/contact"
                sx={{
                  color: '#374151',
                  textDecoration: 'none',
                  fontSize: '0.9rem',
                  fontWeight: 600,
                  transition: 'all 0.2s ease',
                  '&:hover': { color: '#1F2937' },
                  mt: 1,
                  display: 'inline-block',
                }}
              >
                Get In Touch →
              </Link>
            </Stack>
          </Box>
        </Box>

        <Divider sx={{ my: 5, borderColor: 'rgba(55, 65, 81, 0.1)' }} />

        {/* Bottom Section */}
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography variant="body2" sx={{ color: '#9CA3AF', fontSize: '0.85rem' }}>
            © {currentYear} InnoVate Games & Apps. All rights reserved.
          </Typography>
          <Stack direction="row" spacing={3}>
            <Link
              component={RouterLink}
              to="/privacy-policy"
              sx={{
                color: '#9CA3AF',
                textDecoration: 'none',
                fontSize: '0.85rem',
                transition: 'color 0.2s ease',
                '&:hover': { color: '#374151' },
              }}
            >
              Privacy Policy
            </Link>
            <Link
              component={RouterLink}
              to="/terms-of-service"
              sx={{
                color: '#9CA3AF',
                textDecoration: 'none',
                fontSize: '0.85rem',
                transition: 'color 0.2s ease',
                '&:hover': { color: '#374151' },
              }}
            >
              Terms of Service
            </Link>
          </Stack>
        </Stack>
      </Container>
    </Box>
  );
};

export default Footer;
